import AppLayout from '../../components/app-layout/AppLayout'
import MoveInCountdown from '../../components/move-in-countdown/MoveInCountdown'
import MovePrepChecklist from '../../components/move-prep-checklist/MovePrepChecklist'
import { Header, PageStack, PageSubtitle, PageTitle } from './styled'

/**
 * Standalone move-prep workspace. Pairs the move-in countdown widget
 * with the full categorized checklist so the renter can plan, schedule,
 * and tick things off in one surface.
 *
 * @returns {JSX.Element}
 */
const MovePrepPage = (): JSX.Element => {
  return (
    <AppLayout contentMaxWidth="standard">
      <PageStack
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.32 } }}
      >
        <Header>
          <PageTitle>Move-prep</PageTitle>
          <PageSubtitle>
            Everything to do before you turn the key. Knock these out and
            move-in day becomes the easy part.
          </PageSubtitle>
        </Header>

        <MoveInCountdown />
        <MovePrepChecklist />
      </PageStack>
    </AppLayout>
  )
}

export default MovePrepPage
